/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type QueryTrendsRequest = {
  agentId: string;
  body: components.QueryTrendsRequestBody;
};

/** @internal */
export const QueryTrendsRequest$inboundSchema: z.ZodType<
  QueryTrendsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: types.string(),
  body: components.QueryTrendsRequestBody$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
  });
});
/** @internal */
export type QueryTrendsRequest$Outbound = {
  agent_id: string;
  body: components.QueryTrendsRequestBody$Outbound;
};

/** @internal */
export const QueryTrendsRequest$outboundSchema: z.ZodType<
  QueryTrendsRequest$Outbound,
  z.ZodTypeDef,
  QueryTrendsRequest
> = z.object({
  agentId: z.string(),
  body: components.QueryTrendsRequestBody$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function queryTrendsRequestToJSON(
  queryTrendsRequest: QueryTrendsRequest,
): string {
  return JSON.stringify(
    QueryTrendsRequest$outboundSchema.parse(queryTrendsRequest),
  );
}
export function queryTrendsRequestFromJSON(
  jsonString: string,
): SafeParseResult<QueryTrendsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => QueryTrendsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'QueryTrendsRequest' from JSON`,
  );
}
